import { LitElement, html } from 'lit';
// eslint-disable-next-line import/extensions
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { formatText } from '../../../utils';

// eslint-disable-next-line
import styles from '!!lit-css-loader!postcss-loader!sass-loader!./PostCaption.scss';

class PostCaption extends LitElement {
  static styles = [styles];

  static get properties() {
    return {
      caption: { type: String },
      service: { type: String },
      disableLinks: { type: Boolean },
    };
  }

  render() {
    const { caption, service, disableLinks } = this;
    const formattedCaption = formatText(caption, { service, undefined, disableLinks });
    return html`${unsafeHTML(formattedCaption.__html)}<slot></slot>`;
  }
}

export default PostCaption;
